import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { CREATE_FIELD_REGISTRY, CREATE_FIELD_REGISTRY_SUCCESS, CREATE_FIELD_REGISTRY_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createFieldRegistry({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/field-registry`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(response?.data?.message || 'Field created successfully.');
      yield put({
        type: CREATE_FIELD_REGISTRY_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || 'Failed to create field.';
      cogoToast.error(message);
      yield put({
        type: CREATE_FIELD_REGISTRY_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error('Failed to create field.');
    yield put({ type: CREATE_FIELD_REGISTRY_ERROR, payload: error });
  }
}

export function* watchcreateFieldRegistry() {
  yield takeEvery(CREATE_FIELD_REGISTRY, createFieldRegistry);
}

function* createFieldRegistrySaga() {
  yield all([fork(watchcreateFieldRegistry)]);
}

export default createFieldRegistrySaga;
